import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConsentRejected = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint0_linear_4037_4328)",
			d: "M42.49 51.97a1.86 1.86 0 1 1 0 3.73 1.86 1.86 0 0 1 0-3.73Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "m154.26 66.04-.29 6.4-24.57 10.72.26-6.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			stroke: "url(#consent-rejected_svg__paint1_linear_4037_4328)",
			d: "M152.58 94.1 129 104.37l.24-5.28L152.8 88.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "m56.86 108.52-.27 6.39-23.3 10.17v-6.28z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			stroke: "url(#consent-rejected_svg__paint2_linear_4037_4328)",
			d: "m55.2 136.58-19.83 8.64q-.6-.64-1-1.43l-.12-.28a6 6 0 0 1-.47-2.3v-.5l21.64-9.43z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint3_linear_4037_4328)",
			d: "m45.03 62.69-4.31 3.08c-6.55-3.55-5.71-3.1-6.93-3.77v-5.43z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint4_linear_4037_4328)",
			d: "M171 131.2v5.42l-12.72-6.91 4.31-3.08z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint5_linear_4037_4328)",
			d: "M158.83 147.11h-9.97l-8.5-4.62 4.31-3.08z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint6_linear_4037_4328)",
			d: "M191.73 96.75a.58.58 0 1 1 0 1.15.58.58 0 0 1 0-1.15Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint7_linear_4037_4328)",
			d: "m138.06 113.28-4.31 3.08-.08-.05-4.56-7.89z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint8_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M171.5 51.05c0 89.27.22 91.75-.4 92.37a6.4 6.4 0 0 1-6.01 4.2H39.67a6.4 6.4 0 0 1-6.39-6.4V51.05a6.4 6.4 0 0 1 6.4-6.4h125.41a6.4 6.4 0 0 1 6.4 6.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint9_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M161.25 62.96H46.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			stroke: "url(#consent-rejected_svg__paint10_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M42.49 56.2a2.36 2.36 0 1 0 0-4.73 2.36 2.36 0 0 0 0 4.73"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint11_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M49.64 56.19a2.36 2.36 0 1 0 0-4.73 2.36 2.36 0 0 0 0 4.73"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			stroke: "url(#consent-rejected_svg__paint12_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M56.8 56.19a2.36 2.36 0 1 0 0-4.73 2.36 2.36 0 0 0 0 4.73"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint13_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m74.36 107.17-17.77 7.75.27-6.4 11.08-4.84z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint14_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m154.26 66.04-.29 6.4-24.57 10.72.26-6.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint15_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m153.33 88.02-.26 6.41-24.6 10.72.28-6.39z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint16_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m56.86 108.52-.27 6.39-23.3 10.17v-6.28z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint17_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M171.5 58.51v6.28l-17.53 7.66.29-6.41z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint18_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M171.5 80.1v6.3l-18.43 8.03.26-6.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint19_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m55.95 130.5-.26 6.41-20.44 8.9a6.4 6.4 0 0 1-1.97-4.6v-.82z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint20_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M140.68 26.06h-13.82"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint21_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M69.03 173.95a2.36 2.36 0 1 0 0-4.73 2.36 2.36 0 0 0 0 4.73"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			stroke: "url(#consent-rejected_svg__paint22_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M69.22 75.28 64 79.01 40.75 66.36l5.22-3.73z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint23_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m162.56 126.04-5.22 3.73-23.56-12.82 5.22-3.73z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			stroke: "url(#consent-rejected_svg__paint24_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m51.3 88.06-5.22 3.73-12.8-6.96v-6.56z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint25_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m74.86 100.88-5.22 3.72L46.08 91.8l5.22-3.73z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			stroke: "url(#consent-rejected_svg__paint26_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m45.97 62.63-5.22 3.73c-7.26-3.94-5.83-3.16-7.46-4.07v-6.56z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			stroke: "url(#consent-rejected_svg__paint27_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M171.5 130.9v6.56l-14.16-7.7 5.22-3.72z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint28_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M160.8 147.61h-12.06l-9.32-5.06 5.22-3.73z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			stroke: "url(#consent-rejected_svg__paint29_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M97.62 71.39a5.52 5.52 0 0 1 9.55 0l32.25 55.86a5.52 5.52 0 0 1-4.79 8.26h-64.5a5.52 5.52 0 0 1-4.76-8.26z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			stroke: "url(#consent-rejected_svg__paint30_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M102.38 115.76a1.8 1.8 0 0 1-1.7-1.13q-.13-.35-.13-.7v-26.8a1.83 1.83 0 1 1 3.67 0v26.8a1.84 1.84 0 0 1-1.84 1.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			stroke: "url(#consent-rejected_svg__paint31_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M102.38 124.1a2.14 2.14 0 1 0 0-4.28 2.14 2.14 0 0 0 0 4.27"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint32_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M191.73 78.55V91.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint33_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m11.68 51.69-6.2 13.79h11.24l-6.18 13.77"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint34_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M184.43 137.37v6.05H171.1q.4-1.06.4-2.2v-3.85z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint35_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M194.53 140.39a23.75 23.75 0 0 1-46.38 7.22h16.94a6.4 6.4 0 0 0 6.4-6.39v-24.57a23.76 23.76 0 0 1 23.03 23.74"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint36_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m129.66 76.76-.26 6.4-12.33 5.4-2.91-5.04z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint37_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m128.75 98.76-.28 6.4-1.45.63-2.9-5.03z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			stroke: "url(#consent-rejected_svg__paint38_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m89.11 86.1-2.87 5L64 79l5.22-3.72z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint39_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m139 113.22-5.22 3.73-.47-.27-5.52-9.54z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			stroke: "url(#consent-rejected_svg__paint40_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m144.64 138.82-5.22 3.73-12.94-7.04h8.15a5.5 5.5 0 0 0 2.67-.68z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-rejected_svg__paint41_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M65.37 127.25a5.5 5.5 0 0 0-.04 5.47l-9.64 4.21.26-6.4 10.08-4.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			stroke: "url(#consent-rejected_svg__paint42_linear_4037_4328)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m79.22 103.24-2.89 5.01-6.7-3.65 5.23-3.72z"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint0_linear_4037_4328",
				x1: 42.487,
				x2: 42.374,
				y1: 55.495,
				y2: 52.33,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint1_linear_4037_4328",
				x1: 140.901,
				x2: 140.618,
				y1: 102.604,
				y2: 91.127,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint2_linear_4037_4328",
				x1: 44.618,
				x2: 44.37,
				y1: 143.539,
				y2: 133.278,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint3_linear_4037_4328",
				x1: 39.629,
				x2: 39.415,
				y1: 64.778,
				y2: 57.66,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint4_linear_4037_4328",
				x1: 164.419,
				x2: 164.198,
				y1: 135.761,
				y2: 128.112,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint5_linear_4037_4328",
				x1: 150.108,
				x2: 150.021,
				y1: 146.305,
				y2: 140.412,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint6_linear_4037_4328",
				x1: 191.727,
				x2: 191.675,
				y1: 98.082,
				y2: 96.639,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint7_linear_4037_4328",
				x1: 133.396,
				x2: 133.19,
				y1: 115.488,
				y2: 108.917,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint8_linear_4037_4328",
				x1: 102.41,
				x2: 100.57,
				y1: 132.301,
				y2: 63.317,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint9_linear_4037_4328",
				x1: 103.876,
				x2: 103.875,
				y1: 63.806,
				y2: 63.136,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint10_linear_4037_4328",
				x1: 42.487,
				x2: 42.374,
				y1: 55.495,
				y2: 52.33,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint11_linear_4037_4328",
				x1: 49.637,
				x2: 49.524,
				y1: 55.485,
				y2: 52.32,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint12_linear_4037_4328",
				x1: 56.802,
				x2: 56.689,
				y1: 55.485,
				y2: 52.32,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint13_linear_4037_4328",
				x1: 65.48,
				x2: 65.309,
				y1: 113.252,
				y2: 105.714,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint14_linear_4037_4328",
				x1: 141.827,
				x2: 141.544,
				y1: 80.617,
				y2: 69.14,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint15_linear_4037_4328",
				x1: 140.901,
				x2: 140.618,
				y1: 102.604,
				y2: 91.127,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint16_linear_4037_4328",
				x1: 45.072,
				x2: 44.792,
				y1: 122.614,
				y2: 111.517,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint17_linear_4037_4328",
				x1: 162.736,
				x2: 162.47,
				y1: 70.374,
				y2: 61.039,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint18_linear_4037_4328",
				x1: 162.282,
				x2: 162.015,
				y1: 92.301,
				y2: 82.701,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint19_linear_4037_4328",
				x1: 44.618,
				x2: 44.37,
				y1: 143.539,
				y2: 133.278,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint20_linear_4037_4328",
				x1: 133.774,
				x2: 133.772,
				y1: 26.914,
				y2: 26.243,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint21_linear_4037_4328",
				x1: 69.034,
				x2: 68.92,
				y1: 173.244,
				y2: 170.079,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint22_linear_4037_4328",
				x1: 54.987,
				x2: 54.761,
				y1: 76.57,
				y2: 65.598,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint23_linear_4037_4328",
				x1: 148.17,
				x2: 147.942,
				y1: 127.305,
				y2: 116.219,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint24_linear_4037_4328",
				x1: 42.292,
				x2: 42.049,
				y1: 89.775,
				y2: 80.718,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint25_linear_4037_4328",
				x1: 60.47,
				x2: 60.241,
				y1: 102.144,
				y2: 91.057,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint26_linear_4037_4328",
				x1: 39.629,
				x2: 39.415,
				y1: 64.778,
				y2: 57.66,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint27_linear_4037_4328",
				x1: 164.419,
				x2: 164.198,
				y1: 135.761,
				y2: 128.112,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint28_linear_4037_4328",
				x1: 150.108,
				x2: 150.021,
				y1: 146.305,
				y2: 140.412,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint29_linear_4037_4328",
				x1: 102.392,
				x2: 100.971,
				y1: 125.564,
				y2: 80.773,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint30_linear_4037_4328",
				x1: 102.382,
				x2: 96.802,
				y1: 111.228,
				y2: 92.466,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint31_linear_4037_4328",
				x1: 102.382,
				x2: 102.28,
				y1: 123.458,
				y2: 120.597,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint32_linear_4037_4328",
				x1: 192.227,
				x2: 188.793,
				y1: 89.817,
				y2: 82.572,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint33_linear_4037_4328",
				x1: 11.099,
				x2: 9.49,
				y1: 75.152,
				y2: 56.813,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint34_linear_4037_4328",
				x1: 177.763,
				x2: 177.697,
				y1: 142.516,
				y2: 138.46,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint35_linear_4037_4328",
				x1: 171.338,
				x2: 170.172,
				y1: 157.07,
				y2: 125.273,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint36_linear_4037_4328",
				x1: 121.911,
				x2: 121.695,
				y1: 86.798,
				y2: 78.894,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint37_linear_4037_4328",
				x1: 126.439,
				x2: 126.183,
				y1: 104.748,
				y2: 100.046,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint38_linear_4037_4328",
				x1: 76.558,
				x2: 76.319,
				y1: 88.751,
				y2: 78.148,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint39_linear_4037_4328",
				x1: 133.396,
				x2: 133.19,
				y1: 115.489,
				y2: 108.917,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint40_linear_4037_4328",
				x1: 135.558,
				x2: 135.48,
				y1: 141.399,
				y2: 136.229,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint41_linear_4037_4328",
				x1: 60.857,
				x2: 60.587,
				y1: 135.326,
				y2: 128.097,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-rejected_svg__paint42_linear_4037_4328",
				x1: 74.431,
				x2: 74.295,
				y1: 107.155,
				y2: 102.215,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			})
		] })
	]
});
export default SvgConsentRejected;
